<div class="dalog-header-cust">
    <h2>Help & Support</h2>
    <button type="button" class="btn-cust-close" (click)="navService.openSideNav({ toogle: true })">
    <i class="icon-close"></i>
  </button>
</div>
<!-- <button class="btn-close" (click)="navService.openSideNav({ toogle: true })">
  <mat-icon>close</mat-icon>
</button>
<mat-toolbar class="mat-elevation-z0">
  <mat-toolbar-row>
    <div class="notificard">
      <h2>
        <img src="assets/images/help.svg" alt="" class="me-2" /> HELP & SUPPROT
      </h2>
    </div>
  </mat-toolbar-row>
</mat-toolbar> -->
<div class="request">
  <div class="px-3">
    @if (isLoading) {
    <div class="row">
      @for (item of [1,2,3]; track $index) {
      <div class="com-md-12 mb-3">
        <ngx-skeleton-loader
          [theme]="{ height: '10px', width: '50px', background: '#e9edff' }"
        />
        @for (item of [1,2]; track $index) {
        <div class="d-flex flex-column">
          <ngx-skeleton-loader
            [theme]="{ height: '10px', background: '#e9edff' }"
          />
          <ngx-skeleton-loader
            [theme]="{ height: '10px', background: '#e9edff' }"
          />
        </div>
        }
      </div>
      }
    </div>
    } @else {
    <div  [innerHTML]="supportData?.description"></div>
<div class="mt-2">
  @for (item of supportData?.helpSupportQueries??[]; track $index) {
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> {{item?.question}} </mat-panel-title>
          <!-- <mat-panel-description> This is a summary of the content </mat-panel-description> -->
        </mat-expansion-panel-header>
        <p>{{item?.answer}} </p>
      </mat-expansion-panel>
    </mat-accordion>
    
  }
</div>
    }
  </div>
</div>
